import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { State, getSelectedExhibitionId } from '@app/app.reducer';
import { LsButtonComponent } from '@axess/ng-limestone';
import { BaseRoute } from '@core/data-access/models/routes.model';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AppConstants } from '@shared/app-constants';
import { getLocalStorageString, setLocalStorageObject, setLocalStorageString } from '@shared/app-utils';
import { HideTranslationPipe } from '@shared/pipes/hide-translation/hide-translation.pipe';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-cookies-popup',
  templateUrl: './cookies-popup.component.html',
  styleUrls: ['./cookies-popup.component.scss'],
  standalone: true,
  imports: [TranslateModule, HideTranslationPipe, LsButtonComponent]
})
export class CookiesPopupComponent implements OnInit, OnDestroy {
  @Input() textWithLink: string;
  hideDataProtectionOnHomePage = getLocalStorageString(AppConstants.hideDataProtectionOnHomePageReducer) || false;
  hideDataProtectionPageOnEvent =
    JSON.parse(getLocalStorageString(AppConstants.hideDataProtectionOnEventReducer)) || [];
  hideDataProtectionOnEventPage = false;
  eventId: string | number;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private router: Router,
    private store: Store<State>
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.store
        .select(getSelectedExhibitionId)
        .pipe(
          filter((eventId) => {
            this.eventId = eventId;

            return !!eventId;
          })
        )
        .subscribe((eventId) => {
          this.hideDataProtectionPageOnEvent =
            JSON.parse(getLocalStorageString(AppConstants.hideDataProtectionOnEventReducer)) || [];

          this.hideDataProtectionOnEventPage = !!Object.keys(this.hideDataProtectionPageOnEvent).find(
            (id) => id === eventId.toString()
          );
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onClickText($event) {
    $event.stopPropagation();
    $event.preventDefault();

    if ($event.target.tagName === 'A') {
      this.router.navigate([`/${BaseRoute.DataProtection}`]);
    }
  }

  onClose() {
    if (!this.eventId) {
      setLocalStorageString(AppConstants.hideDataProtectionOnHomePageReducer, 'true');

      this.hideDataProtectionOnHomePage = true;
    } else {
      setLocalStorageObject(AppConstants.hideDataProtectionOnEventReducer, {
        ...this.hideDataProtectionPageOnEvent,
        [this.eventId]: true
      });

      this.hideDataProtectionOnEventPage = true;
    }
  }
}
